import React, { useEffect, useState } from "react"
import { Form, Button, Container, Row, Col } from "react-bootstrap"
import { useNavigate, Link } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { toast } from "react-toastify"
import logo from "../assets/images/logo.jpg"
import Footer from "../components/layout/Footer"

const Login = () => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { doLogin, isAuthenticated } = useAuth()

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/")
    }
  }, [isAuthenticated, navigate])

  const handleSubmit = async e => {
    e.preventDefault()

    if (!username.trim() || !password.trim()) {
      toast.error("Παρακαλώ εισάγετε username και κωδικό.")
      return
    }

    setLoading(true)
    const result = await doLogin(username, password)
    if (result) {
      navigate("/")
    }
    setLoading(false)
  }

  return (
    <div className="grid-background">
      <div className="min-vh-100 d-flex flex-column">
        <div className="flex-grow-1 d-flex align-items-center">
          <Container>
            <Row className="justify-content-center">
              <Col xs={12} md={10} lg={8} xl={7}>
                <div className="login-container">
                  <div className="login-logo-wrapper">
                    <img src={logo} alt="eGarages logo" className="login-logo" />
                  </div>
                  <div className="login-form-wrapper">
                    <div className="content-glass p-4 h-100 d-flex flex-column justify-content-center">
                      <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                          <Form.Control
                            type="text"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            disabled={loading}
                            autoComplete="username"
                            placeholder="Username"
                            autoFocus
                          />
                        </Form.Group>

                        <Form.Group className="mb-4">
                          <Form.Control
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            disabled={loading}
                            autoComplete="current-password"
                            placeholder="Κωδικός"
                          />
                        </Form.Group>

                        <div className="d-grid">
                          <Button type="submit" variant="primary" size="lg" disabled={loading}>
                            {loading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Παρακαλώ περιμένετε...
                              </>
                            ) : (
                              "Σύνδεση"
                            )}
                          </Button>
                        </div>
                        <div className="small text-center mt-3">
                          <Link to="/register">Δημιουργία λογαριασμού συνεργείου</Link>
                        </div>
                        <div className="text-center mt-1 small">
                          <Link to="/forgot-password">Ξέχασα τον κωδικό μου</Link>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Footer />
      </div>
      <style>
        {`
          .login-container {
            display: block;
          }
          .login-logo-wrapper {
            width: 100%;
            text-align: center;
            margin-bottom: 1rem;
          }
          .login-form-wrapper {
            width: 100%;
          }

          @media (min-width: 992px) {
            .login-container {
              display: flex;
              align-items: stretch;
            }
            .login-logo-wrapper {
              flex-basis: 50%;
              width: 50%;
              padding-right: 1rem;
              margin-bottom: 0;
            }
            .login-form-wrapper {
              flex-basis: 50%;
              width: 50%;
              padding-left: 1rem;
            }
            .login-logo {
              height: 100%;
              object-fit: contain;
            }
          }
        `}
      </style>
    </div>
  )
}

export default Login
